<script setup lang="ts">
definePageMeta({
  alias: ['/ecommerce'],
  pageType: 'ECOMMERCE',
})
const { validateParamsEcommerce, isError } = useProductDetailRedirect()
const restaurantStore = useRestaurantStore()
const error = ref()

onMounted(() => {
  // Ecommerce query params
  validateParamsEcommerce()
})

watch(isError, newValue => {
  if (newValue) {
    // Trigger error when no parameters exist or the product is not found
    error.value = new Error('Product not found')
    // reset store productIdentifier
    restaurantStore.productIdentifierNotFound = false
  }
})
</script>
<template>
  <LazyErrorView v-if="error" :error="error" />
</template>
